/*
 * "Próximos eventos": as próximas ocorrências, com o bloco da data, o nome e
 * a hora. Aparece no topo da lista da
 * tag dos eventos e leva à página de todos os eventos.
 */
import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Icon from 'flarum/common/components/Icon';
import Link from 'flarum/common/components/Link';
import { monthShort, timeOf } from './format';
import { apiUrl, upcomingFromDocument } from './model';
import { EVENTS_ROUTE } from './route';
import { t } from '../../utils/settings';
/** Os mesmos pedidos por 60 s: a lista da tag redesenha muito. */
let cache = null;
let pending = null;
export function loadUpcoming({
  from,
  to,
  limit
} = {}) {
  const filter = {};
  if (from) filter.from = from;
  if (to) filter.to = to;
  return app.request({
    method: 'GET',
    url: apiUrl('/canela-events'),
    params: {
      filter,
      page: limit ? {
        limit
      } : {},
      include: 'discussion',
      // Da discussão, só o que a linha mostra (o título) e o link (o slug).
      fields: {
        discussions: 'title,slug'
      }
    }
  }).then(payload => upcomingFromDocument(payload)).catch(() => []);
}
function upcoming() {
  if (cache && Date.now() - cache.at < 60000) return Promise.resolve(cache.items);
  pending ||= loadUpcoming({
    limit: 6
  }).then(items => {
    cache = {
      at: Date.now(),
      items
    };
    pending = null;
    return items;
  });
  return pending;
}
export function discussionHref(item) {
  return app.route('discussion', {
    id: item.discussion.slug ? `${item.discussion.id}-${item.discussion.slug}` : item.discussion.id
  });
}
export default class UpcomingEvents extends Component {
  items = cache?.items ?? null;
  oninit(vnode) {
    super.oninit(vnode);
    upcoming().then(items => {
      this.items = items;
      m.redraw();
    });
  }
  view() {
    const items = (this.items || []).slice(0, this.attrs.limit || 4);
    if (!items.length) return null;
    return m("section", {
      className: "CanelaUpcomingEvents"
    }, m("header", {
      className: "CanelaUpcomingEvents-header"
    }, m(Icon, {
      name: "far fa-calendar"
    }), m("h3", null, t('events.upcoming_title')), m(Link, {
      className: "CanelaUpcomingEvents-all",
      href: app.route(EVENTS_ROUTE)
    }, t('events.all_events'))), m("ul", {
      className: "CanelaUpcomingEvents-list"
    }, items.map(item => {
      const start = new Date(item.startsAt);
      return m("li", {
        key: `${item.id}-${item.startsAt}`
      }, m(Link, {
        href: discussionHref(item),
        className: "CanelaUpcomingEvents-item"
      }, m("span", {
        className: "CanelaUpcomingEvents-date",
        "aria-hidden": "true"
      }, m("span", {
        className: "CanelaUpcomingEvents-month"
      }, monthShort(start)), m("span", {
        className: "CanelaUpcomingEvents-day"
      }, start.getDate())), m("span", {
        className: "CanelaUpcomingEvents-info"
      }, m("span", {
        className: "CanelaUpcomingEvents-name"
      }, item.name || item.discussion.title), m("span", {
        className: "CanelaUpcomingEvents-time"
      }, timeOf(start)))));
    })));
  }
}
flarum.reg.add('ramon-canela', 'forum/features/events/UpcomingEvents', UpcomingEvents);